import { render, staticRenderFns } from "./CreateCompanyModal.vue?vue&type=template&id=c2504b06"
import script from "./CreateCompanyModal.vue?vue&type=script&lang=ts"
export * from "./CreateCompanyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports